import dayjs from 'dayjs'
import store from '@/store/index'
// import { STORAGE_NUM, LOAD_AND_UNLOAD_NUM, OPERATE_QUALITY } from '../../../constant/constant.js'
// import { companyAdvanceConfig, logicalWhAdvanceConfig } from '../../../constant/advanceConfig.js'

// 装卸
const loadUnloadSearchList = {
    searchTxt: [
        {
            name: '联系人',
            value: 'contactsLike',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '联系电话',
            value: 'contactNumber',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '岗位',
            value: 'postCodeList',
            type: 'select',
            multiple: true,
            optionNum: 'SRM_POST_TYPE',
            unfold: true,
            span: 3,
        },
        {
            name: '状态',
            value: 'stateList',
            type: 'select',
            multiple: true,
            optionNum: 'IDLE_DEMAND_RESOURCES_STAGE_TYPE',
            unfold: true,
            span: 3,
        },
        {
            name: '意向省份',
            value: 'provinceCode',
            type: 'slot',
            unfold: true,
            span: 3,
        },
        {
            name: '意向城市',
            value: 'cityCodeList',
            type: 'slot',
            unfold: true,
            span: 3,
        },
        {
            name: '计量单位',
            value: 'measurementUnitCode',
            type: 'select',
            optionNum: 'IDLE_DEMAND_RESOURCES_METER_TYPE',
            unfold: true,
            span: 3,
        },
        {
            name: '创建时间',
            value: 'createTimeArr',
            type: 'time',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            timeNum: 180,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近六个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(180, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                ],
            },
            unfold: true,
            span: 6,
        },
        {
            name: '最低价/元',
            value: 'bottomPriceLessThan',
            type: 'slot',
            unfold: false,
            span: 5,
        },
        {
            name: '最低价/元',
            value: 'bottomPriceGreaterThan',
            type: 'slot',
            unfold: true,
            span: 5,
        },
        {
            name: '最高价/元',
            value: 'maximumPriceLessThan',
            type: 'slot',
            unfold: false,
            span: 3,
        },
        {
            name: '最高价/元',
            value: 'maximumPriceGreaterThan',
            type: 'slot',
            unfold: true,
            span: 5,
        },
    ],
    unfoldState: false,
    advancedBtn: true,
    resetBtn: true,
}
const loadUnloadTable = {
    pageId: 'idleResourceLoadUnloadPageId251025',
    selectBtn: true,
    height: 'calc(100vh - 244px)',
    columns: [
        {
            label: '编码',
            prop: 'loadIdleCode',
            width: '140px',
        },
        {
            label: '联系人',
            prop: 'contacts',
            width: '100px',
        },
        {
            label: '联系人电话',
            prop: 'contactNumber_',
            sensitive: true,
            sensitiveValue: true,
            width: '120px',
            ifHas: '/idleResource-70',
        },
        {
            label: '人数',
            prop: 'peopleNumber',
            width: '100px',
        },
        {
            label: '岗位',
            prop: 'postCode',
            type: 'select',
            optionNum: 'SRM_POST_TYPE',
            options: [],
            width: '100px',
        },
        {
            label: '意向省份',
            prop: 'provinceName',
            width: '130px',
        },
        {
            label: '意向城市',
            prop: 'cityName',
            width: '130px',
        },
        {
            label: '意向区县',
            prop: 'areaName',
            width: '130px',
        },
        {
            label: '计量单位',
            prop: 'measurementUnitCode',
            type: 'select',
            optionNum: 'IDLE_DEMAND_RESOURCES_METER_TYPE',
            options: [],
            width: '100px',
        },
        {
            label: '最低价/元/月',
            prop: 'bottomPrice',
            width: '100px',
        },
        {
            label: '最高价/元/月',
            prop: 'maximumPrice',
            width: '100px',
        },
        {
            label: '说明备注',
            prop: 'remark',
            width: '150px',
        },
        {
            label: '开始日期',
            prop: 'startTime',
            width: '100px',
        },
        {
            label: '结束日期',
            prop: 'endTime',
            width: '100px',
        },
        {
            label: '状态',
            prop: 'state',
            type: 'select',
            optionNum: 'IDLE_DEMAND_RESOURCES_STAGE_TYPE',
            options: [],
            width: '100px',
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: '100px',
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: '160px',
        },
        {
            label: '更新人',
            prop: 'updateUserName',
            width: '100px',
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: '160px',
        },
    ],
    action: [
        {
            type: 'text',
            label: '编辑',
            size: 'small',
            event: 'edit',
            ifHas: '/idleResource-20',
        },
        {
            type: 'text',
            label: '点击匹配',
            size: 'small',
            event: 'match',
            ifHas: '/idleResource-50',
        },
        {
            type: 'text',
            label: '查看匹配结果',
            size: 'small',
            event: 'result',
            ifHas: '/idleResource-60',
        },
    ],
    leftOperation: true,
    leftWidth: 220,
}

// 仓库
const warehouseSearchList = {
    searchTxt: [
        {
            name: '联系人',
            value: 'contactsLike',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '联系电话',
            value: 'contactNumber',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '仓库省份',
            value: 'provinceCode',
            type: 'slot',
            unfold: true,
            span: 3,
        },
        {
            name: '仓库城市',
            value: 'cityCodeList',
            type: 'slot',
            unfold: true,
            span: 3,
        },
        {
            name: '仓库类型',
            value: 'warehouseTypeList',
            type: 'select',
            optionNum: 'SYS_SU_WH_TYPE',
            multiple: true,
            unfold: true,
            span: 4,
        },
        {
            name: '消防验收',
            value: 'warehouseFireProtectionLevelList',
            type: 'select',
            optionNum: 'SYS_SU_FIRE_INSPECTION',
            multiple: true,
            unfold: true,
            span: 4,
        },
        {
            name: '是否可租',
            value: 'rentableFlag',
            type: 'select',
            optionNum: 'SRM_PHY_WH_ENABLE_LEASE',
            unfold: true,
            span: 3,
        },
        {
            name: '仓库业主名称',
            value: 'warehouseOwnerNameLike',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '创建时间',
            value: 'createTimeArr',
            type: 'time',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            timeNum: 180,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近六个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(180, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                ],
            },
            unfold: true,
            span: 6,
        },
        {
            name: '最低价',
            value: 'bottomPriceLessThan',
            type: 'slot',
            unfold: false,
            span: 5,
        },
        {
            name: '最低价',
            value: 'bottomPriceGreaterThan',
            type: 'slot',
            unfold: true,
            span: 5,
        },
        {
            name: '最高价',
            value: 'maximumPriceLessThan',
            type: 'slot',
            unfold: false,
            span: 3,
        },
        {
            name: '最高价',
            value: 'maximumPriceGreaterThan',
            type: 'slot',
            unfold: true,
            span: 5,
        },
    ],
    unfoldState: false,
    advancedBtn: true,
    resetBtn: true,
}
const warehouseTable = {
    pageId: 'idleResourceWarehouseId251025',
    selectBtn: true,
    height: 'calc(100vh - 244px)',
    columns: [
        {
            label: '编码',
            prop: 'warehouseIdleCode',
            width: '140px',
        },
        {
            label: '仓库省份',
            prop: 'provinceName',
            width: '130px',
        },
        {
            label: '仓库城市',
            prop: 'cityName',
            width: '130px',
        },
        {
            label: '仓库区县',
            prop: 'areaName',
            width: '130px',
        },
        {
            label: '仓库整体面积/m²',
            prop: 'warehouseArea',
            width: '130px',
        },
        {
            label: '仓库可租面积/m²',
            prop: 'warehouseRentableArea',
            width: '130px',
        },
        {
            label: '仓库类型',
            prop: 'warehouseType_',
            // type: 'select',
            // optionNum: 'SYS_SU_WH_TYPE',
            // options: [],
            width: '180px',
        },
        {
            label: '消防验收',
            prop: 'warehouseFireProtectionLevel',
            type: 'select',
            optionNum: 'SYS_SU_FIRE_INSPECTION',
            options: [],
            width: '100px',
        },
        {
            label: '最低价/元/月',
            prop: 'bottomPrice',
            width: '100px',
        },
        {
            label: '最高价/元/月',
            prop: 'maximumPrice',
            width: '100px',
        },
        {
            label: '是否可租',
            prop: 'rentableFlag',
            type: 'select',
            optionNum: 'SRM_PHY_WH_ENABLE_LEASE',
            options: [],
            width: '100px',
        },
        {
            label: '仓库业主名称',
            prop: 'warehouseOwnerName',
            width: '100px',
        },
        {
            label: '联系人',
            prop: 'contacts',
            width: '100px',
        },
        {
            label: '联系人电话',
            prop: 'contactNumber_',
            sensitive: true,
            sensitiveValue: true,
            width: '120px',
            ifHas: '/idleResource-70',
        },
        {
            label: '仓库图片',
            prop: 'warehousePictureUrl',
            type: 'buttonList',
            buttonList: ['查看'],
            width: '100px',
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: '100px',
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: '160px',
        },
        {
            label: '更新人',
            prop: 'updateUserName',
            width: '100px',
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: '160px',
        },
        
    ],
    action: [
        {
            type: 'text',
            label: '编辑',
            size: 'small',
            event: 'edit',
            ifHas: '/idleResource-20',
        },
        {
            type: 'text',
            label: '点击匹配',
            size: 'small',
            event: 'match',
            ifHas: '/idleResource-50',
        },
        {
            type: 'text',
            label: '查看匹配结果',
            size: 'small',
            event: 'result',
            ifHas: '/idleResource-60',
        },
    ],
    leftOperation: true,
    leftWidth: 220,
}

// 设备类-lsrm
const lsrmDeviceSearchList = {
    searchTxt: [
        {
            name: '联系人',
            value: 'contacts',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '联系电话',
            value: 'contactNumber',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '设备名称',
            value: 'equipmentName',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '省份',
            value: 'provinceCode',
            type: 'slot',
            unfold: true,
            span: 4,
        },
        {
            name: '城市',
            value: 'cityCodeList',
            type: 'slot',
            unfold: true,
            span: 4,
        },
        {
            name: '数据来源',
            value: 'dataSource',
            type: 'select',
            optionNum: 'SRM_IDLE_RESOURCE_DATASOURCE',
            unfold: true,
            span: 3,
        },
        {
            name: '供应商名称',
            value: 'supplierName',
            advanceLabel: '供应商弹出框',
            type: 'advance',
            advanceConfig: [
                { prop: 'ALL', value: '全部' },
                { prop: 'supplierCode', value: '供应商编码' },
                { prop: 'supplierName', value: '供应商名称' },
            ],
            tableConfig: [
                { prop: 'supplierCode', value: '供应商编码' },
                { prop: 'supplierName', value: '供应商名称' },
                { prop: 'supplierTypeName', value: '供应商类型' },
            ],
            cbParams: [
                'supplierCode',
                'supplierName',
            ],
            advanceUrl: '/supplier/getSupplierInfosByNameAndCode',
            extraParams: {
                tenantCode: store.getters.currentTenant.tenantCode
            },
            notFetchOnShow: true,
            queryConditionRequired: true,
            advancePrefix: 'api-srm-web',
            prefix: 'api-srm-web',
            unfold: true,
            span: 4,
        },
        {
            name: '经营中心',
            value: 'centerName',
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '经营中心名称' },
                { prop: 'escoCompanyNo', value: '经营中心编码' },
            ],
            tableConfig: [
                { prop: 'escoCompanyNo', value: '经营中心编码' },
                { prop: 'escoCompanyNameCn', value: '经营中心名称' },
            ],
            method: 'post',
            prefix: '/api-srm-web',
            advanceUrl: '/analysis/mdmService/pageSearchBusinessCenter',
            cbParams: ['escoCompanyNo#centerCode', 'escoCompanyNameCn#centerName'],
            // multiple: true,
            // multipleDelConfirm: true,
            // max: 20,
            // multipleTableColumn: { prop: 'escoCompanyNameCn', value: '经营中心名称' },
            unfold: true,
            span: 4,
        },
        {
            name: '物理仓',
            value: 'physicalWarehouseName',
            type: 'advance',
            advanceLabel: '物理仓',
            advanceConfig: [
                { prop: 'ALL', value: '全部' },
                { prop: 'whName', value: '物理仓名称' },
                { prop: 'whCode', value: '物理仓编码' },
            ],
            tableConfig: [
                { prop: 'whCode', value: '物理仓编码' },
                { prop: 'whName', value: '名称' },
                { prop: 'whAddress', value: '地址' },
                { prop: 'whSquare', value: '仓库面积' },
            ],
            advanceUrl: '/supplier/supplierPhysicsWarehouse/pageList',
            prefix: 'api-srm-web',
            method: 'post',
            cbParams: [
                'whCode#physicalWarehouseCode',
                'whName#physicalWarehouseName',
                // 'whNameArray#physicalWarehouseNameArray',
            ],
            unfold: true,
            span: 4,
        },
        {
            name: '状态',
            value: 'status',
            type: 'select',
            optionNum: 'SRM_EQUIPMENT_RESOURCE_STATUS',
            unfold: true,
            span: 3,
        },
        {
            name: '创建时间',
            value: 'createTimeArr',
            type: 'time',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            timeNum: 180,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近六个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(180, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                ],
            },
            unfold: true,
            span: 6,
        },
    ],
    unfoldState: false,
    advancedBtn: true,
    resetBtn: true,
}
const lsrmDeviceTable = {
    pageId: 'idleResourceDeviceId251025',
    selectBtn: true,
    height: 'calc(100vh - 271px)',
    columns: [
        {
            label: '编码',
            prop: 'equipmentIdleCode',
            width: '140px',
        },
        {
            label: '品牌',
            prop: 'brand',
            width: '150px',
        },
        {
            label: '设备名称',
            prop: 'equipmentName',
            width: '150px',
        },
        {
            label: '规格型号',
            prop: 'specification',
            width: '150px',
        },
        {
            label: '闲置数量',
            prop: 'idleAmount',
            width: '90px',
        },
        {
            label: '经营中心',
            prop: 'centerName',
            width: '150px',
        },
        {
            label: '物理仓',
            prop: 'physicalWarehouseName',
            width: '150px',
        },
        {
            label: '闲置资源省份',
            prop: 'provinceName',
            width: '120px',
        },
        {
            label: '闲置资源城市',
            prop: 'cityName',
            width: '120px',
        },
        {
            label: '供应商名称',
            prop: 'supplierName',
            width: '120px',
        },
        {
            label: '数据来源',
            prop: 'dataSource',
            type: 'select',
            optionNum: 'SRM_IDLE_RESOURCE_DATASOURCE',
            options: [],
            width: '90px',
        },
        {
            label: '供应商编码',
            prop: 'supplierCode',
            width: '120px',
        },
        {
            label: '出厂时间',
            prop: 'leavingFactoryTime',
            width: '100px',
        },
        {
            label: '设备情况说明',
            prop: 'equipmentRemark',
            width: '150px',
        },
        {
            label: '状态',
            prop: 'status',
            type: 'select',
            optionNum: 'SRM_EQUIPMENT_RESOURCE_STATUS',
            options: [],
            width: '60px',
        },
        {
            label: '联系人',
            prop: 'contacts',
            width: '100px',
        },
        {
            label: '联系电话',
            prop: 'contactNumber_',
            sensitive: true,
            sensitiveValue: true,
            width: '110px',
            ifHas: '/idleResource-70',
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: '100px',
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: '160px',
        },
        {
            label: '更新人',
            prop: 'updateUserName',
            width: '100px',
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: '160px',
        },
    ],
    action: [
        {
            type: 'text',
            label: '编辑',
            size: 'small',
            event: 'edit',
            // ifHas: '/idleResource-20',
        },
    ],
    leftOperation: true,
    leftWidth: 60,
}
// 设备类-lsp
const lspDeviceSearchList = {
    searchTxt: [
        {
            name: '联系人',
            value: 'contacts',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '联系电话',
            value: 'contactNumber',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '设备名称',
            value: 'equipmentName',
            type: 'input',
            unfold: true,
            span: 3,
        },
        {
            name: '省份',
            value: 'provinceCode',
            type: 'slot',
            unfold: true,
            span: 4,
        },
        {
            name: '城市',
            value: 'cityCodeList',
            type: 'slot',
            unfold: true,
            span: 4,
        },
        {
            name: '状态',
            value: 'status',
            type: 'select',
            optionNum: 'SRM_EQUIPMENT_RESOURCE_STATUS',
            unfold: true,
            span: 3,
        },
        {
            name: '创建时间',
            value: 'createTimeArr',
            type: 'time',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            timeNum: 180,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近六个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(180, 'd').toDate()
                            const end = dayjs().endOf('day').toDate()
                            picker.$emit('pick', [start, end])
                        },
                    },
                ],
            },
            unfold: true,
            span: 6,
        },
    ],
    unfoldState: false,
    advancedBtn: true,
    resetBtn: true,
}
const lspDeviceTable = {
    pageId: 'idleResourceDeviceId250805',
    selectBtn: true,
    height: 'calc(100vh - 271px)',
    columns: [
        {
            label: '编码',
            prop: 'equipmentIdleCode',
            width: '140px',
        },
        {
            label: '品牌',
            prop: 'brand',
            width: '150px',
        },
        {
            label: '设备名称',
            prop: 'equipmentName',
            width: '150px',
        },
        {
            label: '规格型号',
            prop: 'specification',
            width: '150px',
        },
        {
            label: '闲置数量',
            prop: 'idleAmount',
            width: '90px',
        },
        {
            label: '闲置资源省份',
            prop: 'provinceName',
            width: '120px',
        },
        {
            label: '闲置资源城市',
            prop: 'cityName',
            width: '120px',
        },
        {
            label: '出厂时间',
            prop: 'leavingFactoryTime',
            width: '100px',
        },
        {
            label: '设备情况说明',
            prop: 'equipmentRemark',
            width: '150px',
        },
        {
            label: '状态',
            prop: 'status',
            type: 'select',
            optionNum: 'SRM_EQUIPMENT_RESOURCE_STATUS',
            options: [],
            width: '60px',
        },
        {
            label: '联系人',
            prop: 'contacts',
            width: '100px',
        },
        {
            label: '联系电话',
            prop: 'contactNumber_',
            sensitive: true,
            sensitiveValue: true,
            width: '110px',
        },
        {
            label: '供应商编码',
            prop: 'supplierCode',
            width: '120px',
        },
        {
            label: '供应商名称',
            prop: 'supplierName',
            width: '120px',
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: '100px',
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: '160px',
        },
        {
            label: '更新人',
            prop: 'updateUserName',
            width: '100px',
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: '160px',
        },
    ],
    action: [
        {
            type: 'text',
            label: '编辑',
            size: 'small',
            event: 'edit',
            // ifHas: '/idleResource-20',
        },
    ],
    leftOperation: true,
    leftWidth: 60,
}
    

export default {
    // configuration: true,
    loadUnloadSearchList,
    warehouseSearchList,
    lsrmDeviceSearchList,
    lspDeviceSearchList,
    searchList: loadUnloadSearchList,
    loadUnloadTable,
    warehouseTable,
    lsrmDeviceTable,
    lspDeviceTable,
    table: loadUnloadTable,
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
